import {
  faCheck,
  faPlus,
  faSquareKanban
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useState } from 'react'
import { useUserAcls } from '~/api/queries/user'
import { ButtonGroup } from '~/components/Global/Blocks/ButtonGroup/ButtonGroup'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import {
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
  PageHeader
} from '~/components/Layout/Page'
import { useUpdateConfig } from '~/domains/configuration/mutations/updateConfig'
import { useConfig } from '~/domains/configuration/queries/config'
import { CreateOrderModal } from '~/domains/orders/components/CreateOrderModal'
import { AuthContext } from '~/utils/contextes'

export const Header = () => {
  const { data: configData, isLoading } = useConfig('order.kanban_default')
  const [newOrderModalOpen, setNewOrderModalOpen] = useState(false)
  const currentUser = useContext(AuthContext)
  const { data: userAcls } = useUserAcls(currentUser?.id ?? null)
  const updateConfig = useUpdateConfig()

  const isKanbanDefault = !isLoading ? (configData ?? false) : true

  const handleAccept = () => {
    updateConfig.mutate({
      name: 'order.kanban_default',
      value: true
    })
  }
  return (
    <PageHeader>
      <HeaderTitle>
        <HeaderIcon icon={faSquareKanban} />
        Commandes
      </HeaderTitle>
      <HeaderActions>
        <ButtonGroup align="spaceBetween">
          {!isKanbanDefault && (
            <Button
              variation={ButtonVariation.Secondary}
              onClick={handleAccept}
              buttonSize="small"
              disabled={updateConfig.isPending}
            >
              <FontAwesomeIcon icon={faCheck} />
              Afficher cette vue par défaut
            </Button>
          )}
          {(userAcls === undefined || userAcls.orders.create) && (
            <Button
              buttonSize="small"
              variation={ButtonVariation.Secondary}
              onClick={() => setNewOrderModalOpen(true)}
            >
              Créer une commande
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          )}
        </ButtonGroup>
      </HeaderActions>
      {newOrderModalOpen && (
        <CreateOrderModal open onClose={() => setNewOrderModalOpen(false)} />
      )}
    </PageHeader>
  )
}
